import React from 'react'

const CompanyMessage = () => {
  return (
    <div>CompanyMessage</div>
  )
}

export default CompanyMessage;